module.exports = "/static/assets/c3ed388cfda5c066758f95c14b8e3afa.png";